import "../index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { i18nReady } from "@/i18n";
import { ThemeProvider } from "@/lib/theme";
import { AdminAppRoot } from "./app";

/**
 * The admin app's UI (ADR 0016), built from admin-app.html by vite.admin-app.config.ts. Renders
 * once the language's strings are there.
 */
void i18nReady.then(() =>
  createRoot(document.getElementById("root") as HTMLElement).render(
    <StrictMode>
      <ThemeProvider>
        <AdminAppRoot />
      </ThemeProvider>
    </StrictMode>,
  ),
);
